









































































































import { Inject, Prop, Provide, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGallery from "@/custom/page/filemanager/file/FileGallery.vue";
import { CREATE_MAP, FILE_USER_FORS, getPageCount, viewPageToQueryPage } from "@/constants";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import _ from "lodash";
import ProjectService from "@/entities/project/project.service";
import ConfirmDialog from "@/custom/page/common/ConfirmDialog.vue";

const ALL = 'ALL';
@Component({ components: { FileGallery, ConfirmDialog } })
export default class FileListPage extends Vue {
  @Inject() readonly provincesFn;

  projects = [];
  projectRsData = [];
  projectViews = [];
  files = [];

  @Prop() downloadMode: boolean;

  fileUseForSelect = {
    list: this.addAllSelect(FILE_USER_FORS),
  };

  filter = {
    fileUseFor: ALL,
    project: ALL,
    province: ALL,
  };
  searchValue = '';

  get provincesSelectList() {
    const provinces = this.provincesFn().provinces;
    const provinceMap = CREATE_MAP(provinces);
    return this.addAllSelect(this.projects.map(e => provinceMap[e.province.id]));
  }

  get projectsSelectList() {
    return this.addAllSelect(this.projects);
  }

  addAllSelect(arr = []) {
    return [{ id: ALL, name: 'Tất cả' }, ...arr];
  }

  filterProject() {
    const filter = this.filter;
    const searchString = this.searchValue.toLowerCase();
    return [...this.projects]
      .map(e => ({ ...e }))
      .filter(project => {
        if (filter.project !== ALL) {
          if (project.id !== filter.project) {
            return false;
          }
        }
        if (filter.province !== ALL) {
          if (project.province.id !== filter.province) {
            return false;
          }
        }
        if (project.files) {
          if (filter.fileUseFor !== ALL) {
            project.files = project.files.filter(e => e.filePurpose === filter.fileUseFor);
          }
          project.files = project.files.filter(e => e.fileName.toLowerCase().includes(searchString));
        }
        return true;
      });
  }

  @Provide() refreshPage = () => {
    this.fetchProjectAndFiles();
  };

  filterSearchDebouncedFunc = undefined;

  async mounted() {
    const parent = this;
    this.filterSearchDebouncedFunc = _.debounce(function () {
      parent.projectViews = parent.filterProject();
    }, 200);
    await this.fetchProjectAndFiles();
  }

  @Watch('projectPage.page')
  @Watch('projectPage.size')
  private async fetchProjectAndFiles() {
    const rs = await this.fetchProjects();
    let projects = [...rs.data];
    this.projectRsData = projects;
    this.projectPage.total = parseInt(rs.headers['x-total-count']);
    projects = projects
      .map(e => ({ ...e }))
      .map((project, projectId) => {
        project.filePage = { ...this.filePageDefault };
        this.fetchFiles(project.filePage, project.id).then(rs => {
          project.files = [...rs.data];
          project.files.forEach(file => (file.select = false));
          project.filePage.total = parseInt(rs.headers['x-total-count']);
          project.fileGaleryKey = `${projectId}_${project.filePage.page}`;
        });
        return project;
      });
    this.projects = projects;
    this.projectViews = projects;
  }

  private async fetchProjects() {
    const projectService = new ProjectService();
    return await projectService.retrieve(this.viewPageToQueryPage(this.projectPage));
  }

  private async fetchFiles(filePage, projectId) {
    const fileGeodeticService = new FileGeodeticService();
    return await fileGeodeticService.filter(this.viewPageToQueryPage(filePage), { projectId });
  }

  @Watch('filter.fileUseFor')
  @Watch('filter.project')
  @Watch('filter.province')
  @Watch('searchValue')
  onFilterOrSearchChange(val, oldVal) {
    this.filterSearchDebouncedFunc();
  }

  download() {
    const fileGeodeticService = new FileGeodeticService();
    const downloadFiles = this.projects.flatMap(e => e.files).filter(file => file.select);
    if (downloadFiles.length === 0) {
      (this.$root as any).$bvToast.toast('Chọn file trước khi download', {
        toaster: 'b-toaster-top-center',
        title: 'Chú ý',
        variant: 'info',
        solid: true,
        autoHideDelay: 3000,
      });
      return;
    }
    downloadFiles.forEach(file => fileGeodeticService.download(file.id, file.fileName));
  }

  projectPage = {
    page: 1,
    size: 20,
    total: 20,
  };

  filePageDefault = {
    page: 1,
    size: 10,
    total: 10,
  };

  viewPageToQueryPage(page) {
    return viewPageToQueryPage(page);
  }

  getPageCount(page) {
    return getPageCount(page);
  }

  get pageOfFilePages() {
    return this.projects.map(project => project.filePage.page);
  }

  @Watch('pageOfFilePages', { deep: true })
  onPageOfFilePagesChange(val, oldVal) {
    if (oldVal.length > 0) {
      for (let i = 0; i < val.length; i++) {
        if (val[i] !== oldVal[i]) {
          const project = this.projects[i];
          this.fetchFiles(project.filePage, project.id).then(rs => {
            project.files = [...rs.data];
            project.files.forEach(file => (file.select = false));
            project.fileGaleryKey = `${i}_${project.filePage.page}`;
            this.fileSelect.clear();
            this.hasFileSelect = false;
            this.filterSearchDebouncedFunc();
            this.$forceUpdate(); // TODO: tim hieu xem vi sao project.files ko reactive
          });
        }
      }
    }
  }

  fileSelect = new Set();
  hasFileSelect = false;

  onFileSelectChange(projectIdx, fileIdx, val) {
    // console.log('onFileSelectChange', projectIdx, fileIdx, val);
    const fileId = this.projects[projectIdx].files[fileIdx].id;
    if (val) {
      this.fileSelect.add(fileId);
    } else {
      this.fileSelect.delete(fileId);
    }
    this.hasFileSelect = this.fileSelect.size > 0;
  }

  confirmDialog = {
    open: false,
    title: 'Info',
    content: '',
    onOk: () => undefined,
  };

  showConfirmDialog(title, content, cb) {
    this.confirmDialog.open = true;
    this.confirmDialog.title = title;
    this.confirmDialog.content = content;
    this.confirmDialog.onOk = () => {
      this.confirmDialog.open = false;
      cb();
    };
  }

  async deleteFiles() {
    if (this.fileSelect.size === 0) {
      return;
    }
    const fileGeodeticService = new FileGeodeticService();
    this.showConfirmDialog('Xác nhận', 'Bạn có chắc chắn muốn xóa các files?', async () => {
      try {
        const promises = [];
        this.fileSelect.forEach((fileId: number) => promises.push(fileGeodeticService.delete(fileId)));
        await Promise.all(promises);
        (this.$root as any).$bvToast.toast(`Xóa thành công ${this.fileSelect.size} files`, {
          toaster: 'b-toaster-top-center',
          title: 'Success',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
        this.fileSelect.clear();
        this.hasFileSelect = false;
        // reload
        await this.fetchProjectAndFiles();
      } catch (e) {
        (this.$root as any).$bvToast.toast(`Xóa không thành công, ${e}`, {
          toaster: 'b-toaster-top-center',
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      }
    });
  }

  openProjectMapDetail(projectId) {
    this.$router.push(`/file-manager-page/file-project/${projectId}/map-view`);
  }

  gotoImportFilePage() {
    this.$router.push({ name: 'ImportFilePage' });
  }
}
